// ##### Komarov 2025-09-18
import { SET_IP_INFO } from '../constants';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_IP_INFO:
      return action.payload;
    default:
      return state;
  }
};

